const EMAIL_ADDRESS_CONSTRAINTS = {
  MIN_SIZE: 1,
  MAX_SIZE: 10,
  PATTERN:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};
export default EMAIL_ADDRESS_CONSTRAINTS;
